export default "__VITE_ASSET__savNbZDv__"